import React from "react";
import {Breadcrumbs} from "@mui/material";
import {ShareButton} from "@/features/share-article";
import {formatDMY} from "@/shared/lib/date";
import {useArticleStore} from "@/Stores/Site/Article";
import BaseLayout from "@/Layouts/BaseLayout";
import Svg from "@/Components/Svg";
import Link from "@/Layouts/Link";
import {BlockRenderer} from "@/widgets/editor";
import BlogCarousel from "@/widgets/article/ui/BlogCarousel";
import "@/Scss/Site/BlogDetailed/index.scss";
import "@/Scss/Vendors/_react-editor.scss";

const Index = (props) => {
    const {blogDataDetails = {}, isMobile = false} = props;
    const {article = {}, articlesFromSameCategory = []} = blogDataDetails;
    const {body = {}, category = '', published_at, h1 = '', prevUrl = '', nextUrl = ''} = article;
    const {blocks = []} = body;

    const categoryId = useArticleStore(state => state.categoryId);
    const page = useArticleStore(state => state.page);

    return <BaseLayout {...props}>
        <section className={`section`}>
            <div className={`container`}>
                <div className={`blogPageDetailed`}>
                    <Breadcrumbs className={`breadcrumbs`} maxItems={3} itemsAfterCollapse={2}>
                        <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                        <Link className={`breadcrumbs__link`} href={`/blog`}>Блог</Link>
                        <p className={`breadcrumbs__text`}>{h1}</p>
                    </Breadcrumbs>
                    <div className={`blogPageDetailed__article`}>
                        <h1 className={`h1`}>{h1}</h1>
                        <div className={`blogPageDetailed__nav`}>
                            <Link
                                href={`/blog`}
                                method={`post`}
                                as={'button'}
                                data={{
                                    categoryId,
                                    page
                                }}
                                className={`blogPageDetailed__link`}
                            >
                                <Svg id={`arrowLeft`} className={`svg__back-arrow`} />
                                Назад к списку
                            </Link>
                            <p>{formatDMY(published_at)}</p>
                        </div>
                        <div className={`blogPageDetailed__category`}>
                            <p className={`blogPageDetailed__categoryName`}>{category}</p>
                            <div className={`blogPageDetailed__share`}>
                                <ShareButton text={h1} isMobile={isMobile} />
                            </div>
                        </div>
                        <div className={`blogPageDetailed__body`}>
                            {blocks.map((block, i) => (
                                <BlockRenderer key={i} block={block} />
                            ))}
                        </div>
                        <div className={`blogPageDetailed__nav`}>
                            {prevUrl ?
                                <Link href={`${prevUrl}`} className={`link`}>
                                    <Svg id={`arrowLeft`} className={`svg__blog-arrow-back`} />
                                    Предыдущая
                                </Link>
                                :
                                <div className={`link`}></div>
                            }
                            {nextUrl ?
                                <Link href={`${nextUrl}`} className={`link`}>
                                    Следующая
                                    <Svg id={`arrowRight`} className={`svg__blog-arrow-forward`} />
                                </Link>
                                :
                                <div className={`link`}></div>
                            }
                        </div>
                    </div>
                    {articlesFromSameCategory.length > 0 && (
                        <div className={`blogPageDetailed__other`}>
                            <p className={`blogPageDetailed__otherTitle`}>Другие статьи рубрики</p>
                            <div className={`blogPageDetailed__otherCarousel`}>
                                <BlogCarousel data={articlesFromSameCategory} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    </BaseLayout>
}

export default Index;
